// Page scripts
/* eslint-disable id-length, no-unused-vars */
$j(document).ready(function($) {
	var currentPage = 1;
	//events loading
	$j('#load-more-news').on('click', function() {
		currentPage++;
		$j('#spinner').show();
		$j.ajax({
			type: 'POST',
			url: '/wp-admin/admin-ajax.php',
			data: {
				action: 'epi_load_more_news',
				paged: currentPage
			},
			success: function(response) {
				if (response.html) {
					$j('#news-container').append(response.html);
				}
				if (currentPage >= response.max_pages) {
					$j('#load-more-news').hide();
				}
			},
			complete: function() {
				$j('#spinner').hide();
			}
		});
	});
});
